const getters = {
  isLoading: state => state.loading || state.permissionsLoading,
  error: state => state.error,
  success: state => state.success,
  allTenants: state => state.allTenants
};

export default {
  getters
};
